
/* tslint:disable */
/* eslint-disable */

import { defineComponent, ref, computed } from 'vue'
import { colorLog } from '../../utils/colorLog';
import { rustAxios } from '../../ajax';
import FormInput from '../input/FormInput.vue'
import { Status, validate, required } from '../../utils/validators';

export default defineComponent({
  components: {
    FormInput
  },
  props: {
    postHtml: {
      type: String,
      required: true
    }
  },
  setup () {
    const message = ref();
    const parameter = ref('');
    const parameterStatus = computed<Status>(() => {
      return validate(
        parameter.value, 
        [
          required()
        ]
      )
    })

    const onRust = async () => {
      colorLog("rust message", 1);
      const res = await rustAxios("get", "say", { name: parameter.value });
      if (res == 'Please use command curl http://127.0.0.1:8080/say/?name=MyName \n') {
        message.value = 'Please supply a value before activating function'
      } else {
        message.value = res
      }

    };
    return {
      onRust,
      message,
      parameter,
      parameterStatus
    }
  }
})
